import { gql, TypedDocumentNode } from "@apollo/client";
import {
  OutdatedTranslationsQueryQuery,
  OutdatedTranslationsQueryQueryVariables,
  EditAndApproveEmployeeMutation,
  EditAndApproveEmployeeMutationVariables,
} from "generated/graphql";

const updatedMultilangFields = gql`
  fragment updatedMultilangFields on Employee {
    updatedMultilangFields {
      field
      updatedLanguages
    }
  }
`;

export const OUTDATED_TRANSLATIONS: TypedDocumentNode<
  OutdatedTranslationsQueryQuery,
  OutdatedTranslationsQueryQueryVariables
> = gql`
  ${updatedMultilangFields}

  query OutdatedTranslationsQuery {
    employeesWithOutdatedTranslations {
      id
      fullName
      aboutMe {
        id
        de
        en
        fr
        it
      }
      ...updatedMultilangFields
    }
  }
`;

export const EDIT_AND_APPROVE_EMPLOYEE_MUTATION: TypedDocumentNode<
  EditAndApproveEmployeeMutation,
  EditAndApproveEmployeeMutationVariables
> = gql`
  ${updatedMultilangFields}

  mutation EditAndApproveEmployee($id: ID!, $fields: InputEmployee) {
    editAndApproveEmployee(id: $id, fields: $fields) {
      id
      aboutMe {
        id
        de
        en
        fr
        it
      }
      ...updatedMultilangFields
    }
  }
`;
